import { useEffect, useState } from "react";

export const UndoToast = ({
  onUndo,
  duration = 30000,
  closeToast
}: {
  onUndo: () => Promise<void>;
  duration?: number;
  closeToast?: () => void;
}) => {
  const [progress, setProgress] = useState(100);

  useEffect(() => {
    const startTime = Date.now();
    const interval = setInterval(() => {
      const elapsed = Date.now() - startTime;
      const remaining = Math.max(0, 100 - (elapsed / duration) * 100);
      setProgress(remaining);

      if (remaining <= 0) {
        clearInterval(interval);
        closeToast?.();
      }
    }, 50);

    return () => clearInterval(interval);
  }, [duration, closeToast]);

  return (
    <div className="relative w-full">
      <div className="absolute top-0 left-0 right-0 h-1 bg-alpha-200 rounded-t">
        <div
          className="h-full bg-content-1000-inverted transition-all duration-50 rounded-t"
          style={{ width: `${progress}%` }}
        />
      </div>
      <div className="flex items-center gap-4 justify-between pt-3">
        <span className="text-white text-base font-bold">Task deleted</span>
        <button
          onClick={onUndo}
          className="py-2 px-[14px] h-[40px] min-h-[40px] text-content-1000 bg-content-1000-inverted font-bold text-xs border border-alpha-100 shadow-xs rounded-lg"
        >
          Undo
        </button>
      </div>
    </div>
  );
};
